const paths = {
  ADMANAGER: {
    BASE: 'admanager',
    CREATIVES: 'creatives',
    LINEITEMS: 'lineitems',
    NETWORKS: 'networks',
    ORDERS: 'orders',
  },
  AUTH: {
    BASE: 'auth',
    SIGN_IN: 'sign-in',
    SIGN_OUT: 'sign-out',
  },
  DASHBOARD: {
    BASE: 'dashboard',
    ALL_DATA: 'all-data',
  },
  DEVELOP: {
    BASE: 'develop',
    TOOLS: 'tools',
  },
  DOCS: {
    BASE: 'docs',
    BACKLOG: 'backlog',
    DATA_REFRESH: 'data-refresh',
    DEPRECATION: 'deprecation',
    DOCS: 'docs',
    RELEASES: 'releases',
    PRIVACY_POLICY: 'privacy-policy',
    WHITELIST: 'whitelist',
  },
  DELIVERY: {
    BASE: 'delivery',
    DISCREPANCY: 'discrepancy',
    PACING: 'pacing',
  },
  HOME: {
    BASE: 'home',
  },
  INTERNAL: {
    BASE: 'internal',
    ORGANIZATION: 'organization',
    PERSON: 'person',
    PROJECT: 'project',
    TIME_ROLLUP: 'time-rollup',
    TIME_SHEET: 'time-sheet',
  },
  PROGRAMMATIC: {
    BASE: 'programmatic',
    ADX_HEALTH: 'adx-health',
    NETWORK_HEALTH: 'network-health',
    ADX_AND_OPEN_BIDDING: 'adx-and-open-bidding',
  },
  CUSTOM_ANALYTICS: {
    BASE: 'custom-analytics',
    CAMPAIGN_TRACKING: 'campaign-tracking',
    CAMPAIGN_TRACKING_1: 'campaign-tracking-1',
    CAMPAIGN_TRACKING_2: 'campaign-tracking-2',
    MONTHLY_PROGRESS: 'monthly-progress',
    PROGRESS_REPORT: 'progress-report',
    REVENUE: 'revenue',
    REVENUE_AT_RISK: 'revenue-at-risk',
  },
}

export default paths
